import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { ProofSection } from '../components/ProofSection';
import { LearnSection } from '../components/LearnSection';
import { ProgramDetails } from '../components/ProgramDetails';
import { MentorSection } from '../components/MentorSection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { BeforeSection } from '../components/BeforeSection';
import { AfterSection } from '../components/AfterSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { BonusSection } from '../components/BonusSection';
import { FaqAccordion } from '../components/FaqAccordion';
import { CostOfInactionSection } from '../components/CostOfInactionSection';
import { CommunitySection } from '../components/CommunitySection';
import { TrustSection } from '../components/TrustSection';
import { FinalMentorSection } from '../components/FinalMentorSection';
import { Footer } from '../components/Footer';
import { StickyRibbon } from '../components/StickyRibbon';
import { BrandsMarquee } from '../components/BrandsMarquee';
export function LandingPage() {
  return <div className="w-full min-h-screen flex justify-center bg-brand-navy" data-id="element-383">
      <StickyRibbon data-id="element-384" />
      {/* Main Container */}
      <main className="w-full bg-[#FCFBFA] relative overflow-x-hidden pt-[80px] md:pt-[120px]" data-id="element-385">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-[800px] bg-gradient-to-b from-brand-cream/80 via-[#D98BAF]/10 to-transparent pointer-events-none z-0" data-id="element-386"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-lavender/30 rounded-full blur-[120px] pointer-events-none z-0 translate-x-1/3 -translate-y-1/4" data-id="element-387"></div>

        <HeroSection data-id="element-388" />
        <div className="px-6 pb-4 relative z-10" data-id="element-389">
          <BrandsMarquee data-id="element-390" />
        </div>
        <IntroSection data-id="element-391" />
        <ProofSection data-id="element-392" />
        <LearnSection data-id="element-393" />
        <ProgramDetails data-id="element-394" />
        <MentorSection data-id="element-395" />
        <PortfolioCarousel data-id="element-396" />
        <BeforeSection data-id="element-397" />
        <AfterSection data-id="element-398" />
        <TestimonialsSection data-id="element-399" />
        <BonusSection data-id="element-400" />
        <ModulesSection data-id="element-401" />
        <TrustSection data-id="element-402" />
        <CommunitySection data-id="element-403" />
        <PricingSection data-id="element-404" />
        <FinalMentorSection data-id="element-405" />
        <FaqAccordion data-id="element-406" />
        <CostOfInactionSection data-id="element-407" />
        <Footer data-id="element-408" />
      </main>
    </div>;
}